"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import ItemShop from "@/components/virtual-shop/elements/item-shop/ItemShop.vue";
import { Component, PropSync, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
let ColumnUsers = class extends Mixins(AccountSessionMixins) {
  chooseAdmin() {
    this.$emit("chooseAdmin", this._column);
  }
  get show() {
    if (this._controller.query.filter.group === "shopgroup_system_recycle") {
      return false;
    }
    return true;
  }
};
__decorateClass([
  PropSync("column")
], ColumnUsers.prototype, "_column", 2);
__decorateClass([
  PropSync("controller")
], ColumnUsers.prototype, "_controller", 2);
ColumnUsers = __decorateClass([
  Component({
    components: {
      ItemShop
    }
  })
], ColumnUsers);
export {
  ColumnUsers as default
};
